export default __webpack_public_path__ + "static/media/dep3_2.17e48eef.png";